import { useId } from "react";

import { cn } from "@/lib/cn";

/** One row of a choice between sign-in methods: a native radio, so arrows move between the rows. */
export const AuthOption = (props: {
  name: string;
  title: string;
  subtitle: string;
  isSelected: boolean;
  onSelect: () => void;
}) => {
  const { name, title, subtitle, isSelected, onSelect } = props;
  const titleId = useId();
  const subtitleId = useId();
  return (
    <label
      className={cn(
        "mt-6 flex cursor-pointer items-start gap-3 rounded-lg border px-4 py-3 transition-colors",
        "has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-ring",
        isSelected
          ? "border-primary-hover bg-primary-wash"
          : "border-border bg-background hover:bg-primary-wash",
      )}
    >
      <input
        type="radio"
        name={name}
        checked={isSelected}
        onChange={onSelect}
        // The whole row is the label for the pointer; the title alone names the radio, the subtitle
        // is read after it
        aria-labelledby={titleId}
        aria-describedby={subtitleId}
        className="mt-1 size-4 shrink-0 cursor-pointer accent-primary focus-visible:outline-hidden"
      />
      <span className="flex flex-col">
        <span id={titleId} className="text-lg leading-6 text-foreground">
          {title}
        </span>
        <span id={subtitleId} className="text-sm leading-6 text-muted-foreground">
          {subtitle}
        </span>
      </span>
    </label>
  );
};
